import { ApolloError } from "@apollo/client";
import {
  QUERY_PROGRESS_FAILED,
  QUERY_PROGRESS_NOT_STARTED,
  QUERY_PROGRESS_PENDING,
  QUERY_PROGRESS_SUCCEED,
} from "core/consts";
import { QueryProgress, QueryProgressActive } from "core/types";

export function composeProgress<OnlyLoading extends boolean = false>(
  progresses: Array<QueryProgress>,
  onlyLoading?: OnlyLoading,
): OnlyLoading extends true ? QueryProgressActive : QueryProgress {
  let result: QueryProgress = QUERY_PROGRESS_NOT_STARTED;

  if (progresses.includes(QUERY_PROGRESS_PENDING)) {
    result = QUERY_PROGRESS_PENDING;
  } else if (!onlyLoading) {
    if (progresses.includes(QUERY_PROGRESS_FAILED)) {
      result = QUERY_PROGRESS_FAILED;
    } else if (progresses.includes(QUERY_PROGRESS_SUCCEED)) {
      result = QUERY_PROGRESS_SUCCEED;
    }
  }

  return result as OnlyLoading extends true ? QueryProgressActive : QueryProgress;
}

export function isLoading(progress: QueryProgress | QueryProgress[]): boolean {
  if (Array.isArray(progress)) {
    return progress.some((p) => p === QUERY_PROGRESS_PENDING);
  }
  return progress === QUERY_PROGRESS_PENDING;
}

export function logError(error: ApolloError) {
  const isMock = error.networkError?.message?.includes(
    "No more mocked responses",
  );
  if (!isMock) console.error("[Apollo] ", error);
}
